import { alpha, Button, Stack, TableCell, Typography } from "@mui/material";
import { useState } from "react";
import { formatEffortValue } from "~/components/FirewatchRow/Cells/firewatchTableCellUtils";
import { ManualEffort } from "~/operations";
import { TopActionsEffortTooltip } from "~/pages/space/home-dashboard/TopActionsCard/components/TopActionsEffortTooltip";

interface TopActionsCardEffortCellProps {
  effort: number;
  manualEffort?: ManualEffort | null;
  isInitiative?: boolean;
}

const TopActionsCardEffortCell = ({
  effort,
  manualEffort,
  isInitiative,
}: TopActionsCardEffortCellProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setTooltipOpen(!tooltipOpen);
  };

  const handleClose = () => {
    setTooltipOpen(false);
  };

  // Provide default manual effort if null/undefined
  const defaultManualEffort: ManualEffort = {
    totalManualEffort: 0,
    research: 0,
    scripting: 0,
    rollout: 0,
    verification: 0,
    __typename: "ManualEffort",
  };

  const effectiveManualEffort = manualEffort || defaultManualEffort;

  // Get the multiplier of how much faster the mondoo effort is compared to the manual effort.
  const multiplier =
    Number.isFinite(effort) && effort > 0
      ? Math.round(effectiveManualEffort.totalManualEffort / effort)
      : 0;

  return (
    <TableCell
      sx={{
        pl: "5px !important",
        height: "38px",
        width: "140px",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="caption">{formatEffortValue(effort)}</Typography>
        <TopActionsEffortTooltip
          isInitiative={isInitiative}
          tooltipOpen={tooltipOpen}
          handleClose={handleClose}
          handleClick={handleClick}
          effort={{
            mondooEffort: effort,
            manualEffort: effectiveManualEffort,
          }}
        >
          <Typography
            component={Button}
            sx={{
              p: 0.5,
              py: 0.25,
              backgroundColor: (theme) =>
                alpha(theme.palette.primary.main, 0.1),
              color: "text.secondary",
              borderRadius: 1,
              fontSize: 10,
              textTransform: "none",
              lineHeight: "16px",
              whiteSpace: "nowrap",
            }}
          >
            {multiplier}x FASTER
          </Typography>
        </TopActionsEffortTooltip>
      </Stack>
    </TableCell>
  );
};

export default TopActionsCardEffortCell;
